import jwt_decode from "jwt-decode";

export const jwtDecoder = (input) => {
  let decoded = {};
  if (input === undefined) return decoded;
  return input !== null ? (decoded = jwt_decode(input)) : decoded;
};
